import { SentryService } from 'libs/sdk/src/lib/sentry';
import { lazy, useEffect } from 'react';

import { FullPageLoader } from './components/Loaders';
import { EFeatureFlags } from './types';

import { useFeatureFlag, useHubspot } from '@/hooks';
import { useProfile } from '@/store';

const AppView = lazy(() => import('@/views').then(module => ({ default: module.AppView })));
const PublicView = lazy(() => import('@/views').then(module => ({ default: module.PublicView })));
const MaintenanceView = lazy(() =>
  import('@/views').then(module => ({ default: module.MaintenanceView }))
);

export const App = () => {
  const {
    profile,
    isLoading,
    roleCheck: { isAdmin }
  } = useProfile();

  const isMaintenanceMode = useFeatureFlag(EFeatureFlags.MAINTENANCE_MODE);

  const { init: initHubspot } = useHubspot();

  useEffect(() => {
    if (profile) {
      SentryService.initialize(profile, import.meta.env.PROD, import.meta.env.VITE_API_URL);
      initHubspot(profile);
    }
  }, [profile?._id]);

  if (isLoading) return <FullPageLoader />;

  if (profile) {
    if (isMaintenanceMode && !isAdmin) return <MaintenanceView />;
    return <AppView />;
  }

  return <PublicView />;
};

export default App;
